import React, { createContext, useState, useContext, ReactNode } from 'react';

export type CommentType = 'DEFAULT' | 'PRE-CONTRACTOR' | 'POST-CONTRACTOR';
export type SubmittalStage = 'CURRENT' | 'RELEASED_TO_CONTRACTOR' | 'RETURNED_FROM_CONTRACTOR';

const CommentTypeToSubmittalStage: Record<CommentType, SubmittalStage> = {
  DEFAULT: 'CURRENT',
  'PRE-CONTRACTOR': 'RELEASED_TO_CONTRACTOR',
  'POST-CONTRACTOR': 'RETURNED_FROM_CONTRACTOR'
}

export const availableTypes: CommentType[] = ['DEFAULT', 'PRE-CONTRACTOR', 'POST-CONTRACTOR'];

interface CommentTypeContextType {
  commentType: CommentType;
  submittalStage: SubmittalStage;
  setCommentType: (type: CommentType) => void;
}

const CommentTypeContext = createContext<CommentTypeContextType | undefined>(undefined);

export const useCommentType = () => {
  const context = useContext(CommentTypeContext);
  if (context === undefined) {
    throw new Error('useCommentType must be used within a CommentTypeProvider');
  }
  return context;
};

interface CommentTypeProviderProps {
  children: ReactNode;
}

export const CommentTypeProvider: React.FC<CommentTypeProviderProps> = ({ children }) => {
  const [commentType, setCommentType] = useState<CommentType>('DEFAULT');

  return (
    <CommentTypeContext.Provider value={{
      commentType,
      submittalStage: CommentTypeToSubmittalStage[commentType],
      setCommentType
    }}>
      {children}
    </CommentTypeContext.Provider>
  );
};

export { CommentTypeContext };